import { render, staticRenderFns } from "./RegisterClientForm.vue?vue&type=template&id=67dcf26c&scoped=true"
import script from "./RegisterClientForm.vue?vue&type=script&lang=js"
export * from "./RegisterClientForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterClientForm.vue?vue&type=style&index=0&id=67dcf26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcf26c",
  null
  
)

export default component.exports